<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Términos y condiciones</h1>

      <p>
        En Blackfon, queremos ofrecerte una experiencia de compra segura y transparente. A continuación, te presentamos nuestras políticas de compra, envíos y devoluciones.
      </p>

      <br />
      <h6>1. Proceso de Compra</h6>
      <ul>
        <li>
          Selecciona tus productos y agrégales al carrito.
        </li>
        <li>
          Completa la información de envío y pago.
        </li>
        <li>
          Recibirás un correo de confirmación con los detalles de tu pedido.
        </li>
      </ul>

      <br />
      <h6>2. Métodos de Pago</h6>
      <p>
        Aceptamos pagos con:
      </p>
      <ul>
        <li>
          Tarjetas de crédito y débito (Visa, Mastercard, AMEX).
        </li>
        <li>
          Transferencias bancarias (sujeto a confirmación).
        </li>
      </ul>

      <br />
      <h6>3. Envíos</h6>
      <ul>
        <li><strong>Cobertura:</strong> Realizamos envíos a toda la República Mexicana.</li>
        <li><strong>Tiempo de entrega:</strong> De 3 a 7 días hábiles, dependiendo de tu ubicación.</li>
        <li><strong>Costo de envío:</strong> Calculado en el checkout. Envío gratis en compras superiores a $3,000.00 M.N.</li>
        <li><strong>Seguimiento:</strong> Recibirás un número de rastreo por correo electrónico.</li>
      </ul>

      <br />
      <h6>4. Cambios y Devoluciones</h6>
      <p>
        Si no estás satisfecho con tu compra, puedes solicitar un cambio o devolución en un plazo de 7 días después de recibir tu pedido.
      </p>

      <p>
        <strong>Condiciones:</strong>
      </p>
      <ul>
        <li>El producto debe estar en perfecto estado, con etiquetas y empaque original.</li>
        <li>No se aceptan devoluciones de productos personalizados o en oferta.</li>
        <li>El cliente cubre el costo de envío en devoluciones, salvo en casos de productos defectuosos.</li>
      </ul>

      <br />
      <p>
        Para iniciar un proceso de cambio o devolución, escríbenos a contacto@blackfon.mx con tu número de pedido y motivo de la solicitud.
      </p>

      <br />
      <h6>5. Garantía de Productos</h6>
      <p>
        Todos nuestros productos cuentan con garantía por defectos de fabricación por un período de 30 días naturales.
      </p>

      <br />
      <h6>6. Cancelaciones</h6>
      <ul>
        <li>Puedes cancelar tu pedido antes de que sea enviado, enviando un correo a contacto@blackfon.mx</li>
        <li>Si el pedido ya fue procesado, deberás esperar a recibirlo y solicitar una devolución.</li>
      </ul>

      <br />
      <h6>7. Atención al Cliente</h6>
      <p>
        Si tienes dudas o necesitas ayuda, contáctanos por:<br />
        contacto@blackfon.mx
      </p>

      <br />
      <p>
        ¡Gracias por comprar en Blackfon! Queremos que luzcas espectacular en tus eventos más especiales.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
